import emojis from "./emojis.png";
import data from "emoji-mart/data/twitter.json";
import { EmojiSet, Data } from "emoji-mart";

export const setName: EmojiSet = "twitter";
export const fetchBackgroundImage = () => emojis;
export const setData: Data = data as any;
